<template>
  <div id="app" :class="vueAppClasses">
    <!-- Router outlet -->
    <router-view @setAppClasses="setAppClasses" />
    <ChatBot v-if="isLoggedIn" />
  </div>

</template>

<script>
import themeConfig from '@/../themeConfig.js'
import jwt from "@/http/requests/auth/jwt/index.js"
import AuthService from "@/auth/authService.js"
import ChatBot from './components/ChatBot/ChatBot.vue';

export default {
  name: "App",

  data() {
    return {
      vueAppClasses: [],
      qOpen: false,
      qUrl: null,
      loggedIn: false
    }
  },
  components: {
    ChatBot
  },
  computed: {
    isLoggedIn() {
      return this.loggedIn
    }
  },

  watch: {
    '$store.state.theme'(val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl'(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr")
    },
    '$route'() {
      // Check auth status on every route change
      this.updateAuthStatus()
    },

  },

  methods: {
    toggleClassInBody(className) {
      if (className === 'dark') {
        document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-dark')
      } else if (className === 'semi-dark') {
        document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      } else {
        document.body.classList.remove('theme-dark', 'theme-semi-dark')
      }
    },

    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr)
    },

    handleWindowResize() {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },

    handleScroll() {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    },

    updateAuthStatus() {
      this.loggedIn = AuthService.isAuthenticated()
    }
  },

  async mounted() {
    if (localStorage.getItem('shouldReloadAfterLogin') === 'true') {
      localStorage.removeItem('shouldReloadAfterLogin')
      window.location.reload()
    }

    if (localStorage.getItem('shouldReloadAfterLogout') === 'true') {
      localStorage.removeItem('shouldReloadAfterLogout')
      window.location.reload()
    }

    this.toggleClassInBody(themeConfig.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)
    document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)

    // Initialize auth status
    this.updateAuthStatus()

    // Listen for login/logout events
    AuthService.on("loginEvent", (evt) => {
      this.loggedIn = evt.loggedIn
    })
  },

  async created() {
    jwt.init()
    document.documentElement.setAttribute("dir", this.$vs.rtl ? "rtl" : "ltr")

    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.handleScroll)

    try {
      await AuthService.renewTokens()
      this.updateAuthStatus()
    } catch (e) {
      console.error(e)
      this.loggedIn = false
    }
  },

  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
}
</script>
